import { Helmet } from "react-helmet";
import ResizableHeader from "@/components/ResizableHeader";
import Footer from "@/components/Footer";
import { ContactFormSection } from "@/components/contact-form-section";

export function Contact() {
  return (
    <div className="min-h-screen bg-gradient-subtle flex flex-col">
      <Helmet>
        <title>Contact | BankConvert</title>
        <meta name="description" content="Get in touch with the BankConvert team — questions, feedback, or support for converting bank statements to Excel." />
        <link rel="canonical" href="https://www.bankconvert.org/contact" />
      </Helmet>
      <ResizableHeader />
      <main className="flex-1">
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
}
